const state = {
  alertAtualizacoes: {
    status: false,
    show: false
  }
}

const mutations = {
  setAlertAtualizacoes (state, obj) {
    state.alertAtualizacoes = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/alertAtualizacoes.js